import { LevelData } from '../level-data';

export const level16: LevelData = {
    name: 'Expert Trail',
    timeLimit: 110,
    track: [
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
